import { dataHooks } from '@wix/data-hooks'

export const wixMobileCategoryDataHooks = dataHooks<{
  back: {}
  next: {}
  skip: {}
  stepProgressBar: {}
  title: {}
  subtitle: {}
  suggestions: {}
}>('wix-mobile-category')
